import { AxiosError } from 'axios'

export type FailRequestQueue = {
  onSuccess: (token?: string) => void
  onFailure: (error: AxiosError) => void
}

class FailedRequestQueue {
  private queue: Map<string, FailRequestQueue> = new Map<string, FailRequestQueue>()

  add(id: string, onSuccess: (value: any) => void, onFailure: (error: AxiosError) => void) {
    if (!this.queue.has(id)) {
      this.queue.set(id, { onFailure, onSuccess })
    }
  }

  resolveAll(token?: string) {
    this.queue.forEach(({ onSuccess }) => onSuccess(token))
  }

  rejectAll(error: AxiosError) {
    this.queue.forEach(({ onFailure }) => onFailure(error))
  }

  clear() {
    this.queue.clear()
  }

  printQueue() {
    for (const [key] of this.queue.entries()) {
      console.log(`Queue ID: ${key}, Success Handler: calling`)
    }
  }
}

export const failRequestQueue = new FailedRequestQueue()
